<template>
  <div class="stats-chart">
    <div class="headline">
      <h2 class="col s12 m6">Historia kalkulacji</h2>
      <div class="col s12 m6">
        <select v-model="activeSet" class="stats-active-set browser-default">
          <option v-for="(item, index) in statSets" v-bind:value="index">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>

    <vue-chart class="col s12"
      :chartType="chartType"
      :columns="columns"
      :rows="rows"
      :options="options"
      language="pl"
    />
    <Loader :loading="getPendingHistory"/>
  </div>
</template>

<script>
import Loader from '@/components/loader'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('statistics')
export default {
  components: { Loader },
  props: ['chartType'],
  data () {
    return {
      activeSet: 'all',
      statSets: {
        all: {
          name: 'Wszystkie kalkulacje',
          rows: ['date', 'started', 'completed'],
          columns: [
            {
              'type': 'date',
              'label': 'Data'
            },
            {
              'type': 'number',
              'label': 'Rozpoczęte kalkulacje'
            },
            {
              'type': 'number',
              'label': 'Zakończone kalkulacje'
            }
          ]
        },
        started: {
          name: 'Rozpoczęte kalkulacje',
          rows: ['date', 'started'],
          columns: [
            {
              'type': 'date',
              'label': 'Date'
            },
            {
              'type': 'number',
              'label': 'Rozpoczęte kalkulacje'
            }
          ]
        },
        completed: {
          name: 'Zakończone kalkulacje',
          rows: ['date', 'completed'],
          columns: [
            {
              'type': 'date',
              'label': 'Date'
            },
            {
              'type': 'number',
              'label': 'Zakończone kalkulacje'
            }
          ]
        }
      },
      options: {
        title: '',
        hAxis: { title: '' },
        vAxis: { title: '', viewWindow: {min: 0}, gridlines: {count: 4} },
        legend: 'none',
        curveType: 'function',
        pointSize: 3,
        animation: { duration: 500, easing: 'out' }
      }
    }
  },
  created () {
    this.$store.dispatch('statistics/getCalculationHistory', 'get')
  },
  computed: {
    ...mapGetters([
      'getPendingHistory',
      'getCalculationHistory'
    ]),
    rows () {
      const statKeys = this.statSets[this.activeSet].rows
      let rows = []
      const data = this.getCalculationHistory
      for (let i in data) {
        let item = []
        statKeys.map((key) => {
          item.push(key === 'date' ? new Date(data[i][key]) : data[i][key])
        })
        rows.push(item)
      }
      return rows
    },
    columns () {
      return this.statSets[this.activeSet].columns
    }
  }
}
</script>

<style lang="scss">
@import 'src/stylesheets/variables';

.stats-chart {
  min-height: 300px;

  select.stats-active-set {
    max-width: 200px;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// statsChart.vue?adfbeaec